import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
const FormTitle = ({title}) => (
  <MDBox pb={1}>
    <MDTypography color="info" variant="h3">
      {title}
    </MDTypography>
  </MDBox>
);

export default FormTitle;
